import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n-lite';
import * as connectionActions from '../../actions/connectionActions';
import * as contentActions from '../../actions/contentActions';
import { bindActionCreators } from 'redux';
import { CONNECTION } from '../../const';
import PropTypes from 'prop-types';

class NotConnection extends React.Component {
  statusText;
  statusClass;

  tryToReconnect = () => {
    this.props.connectionActions.manualTryToConnect(false);
  };

  setStatusClass = () => {
    const { contentActions, connectionStatus, inClassroom } = this.props;

    this.statusText = '';
    this.statusClass = 'success';

    if (!connectionStatus.network) {
      this.statusText = I18n.t('connection.networkKO');
      this.statusClass = 'error';
    } else if (!connectionStatus.backend) {
      this.statusText = I18n.t('connection.backendKO');
      this.statusClass = 'warning';
    } else if (!connectionStatus.rabbit && inClassroom) {
      this.statusText = I18n.t('connection.rabbitKO');
      this.statusClass = 'warning';
    }

    if (!connectionStatus.online) {
      contentActions.pauseContentBooksDownloads();
    }
  };

  getTryReconnect = () => {
    return (
      <span className="link" onClick={this.tryToReconnect.bind(this)}>
        {I18n.t('connection.tryToReconnect')}
      </span>
    );
  };

  getWaitForReconnect = () => {
    const { attempts } = this.props;

    return (
      <span>
        {I18n.t('connection.waitToReconnect')} {attempts} {I18n.t('common.of')} {CONNECTION.TIMES_RECONECT}{' '}
      </span>
    );
  };

  render() {
    const { attempts } = this.props;

    let tryToReconnectText =
      attempts <= CONNECTION.TIMES_RECONECT ? this.getWaitForReconnect() : this.getTryReconnect();
    this.setStatusClass();

    return (
      <div className="top-bar-messages">
        <div className={this.statusClass}>
          <span className="text">{this.statusText}</span>
          {tryToReconnectText}
        </div>
      </div>
    );
  }
}

NotConnection.propTypes = {
  contentActions: PropTypes.object,
  connectionActions: PropTypes.object,
  connectionStatus: PropTypes.object,
  inClassroom: PropTypes.bool,
  attempts: PropTypes.number
};

function mapStateToProps(state) {
  return {
    connectionStatus: state.connection.status,
    attempts: state.connection.attempts,
    trying: state.connection.trying,
    inClassroom: state.router.inClassroom
  };
}

function mapDispatchToProps(dispatch) {
  return {
    connectionActions: bindActionCreators(connectionActions, dispatch),
    contentActions: bindActionCreators(contentActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(NotConnection);
